import { render, staticRenderFns } from "./welfarePackage.vue?vue&type=template&id=84878434&scoped=true"
import script from "./welfarePackage.vue?vue&type=script&lang=js"
export * from "./welfarePackage.vue?vue&type=script&lang=js"
import style0 from "./welfarePackage.vue?vue&type=style&index=0&id=84878434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84878434",
  null
  
)

export default component.exports